export type ListingIndicator = 'listed' | 'hidden' | 'archived' | 'draft' | 'unknown'

/**
 * Determines the Listing/Visibility indicator shown on the Inventory grid.
 *
 * Priority:
 * - draft always wins
 * - removed wins (not in current inventory membership)
 * - archived inventory state is not listed
 * - then use dealer website visibility
 */
export function getInventoryListingIndicator(v: {
  publishState?: 'draft' | 'published' | string
  membershipStatus?: 'CURRENT' | 'REMOVED' | string
  inventoryState?: string
  websiteVisibility?: string
}): ListingIndicator {
  const publishState = String(v?.publishState || '').trim().toLowerCase()
  if (publishState === 'draft') return 'draft'

  const membershipStatus = String(v?.membershipStatus || '').trim().toUpperCase()
  if (membershipStatus === 'REMOVED') return 'archived'

  const inventoryState = String(v?.inventoryState || '').trim().toUpperCase()
  if (inventoryState === 'ARCHIVED') return 'archived'

  const websiteVisibility = String(v?.websiteVisibility || '').trim().toUpperCase()
  if (websiteVisibility === 'VISIBLE') return 'listed'
  if (websiteVisibility === 'HIDDEN') return 'hidden'

  return 'unknown'
}

